import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';
import MiniCartContainer from './Containers/MiniCart.container';
import QuickSearchContainer from './Containers/QuickSearch.container';
import NavigationContainer from './Containers/Navigation.container';
import FacetedSearchContainer from './Containers/FacetedSearch.container';
import FacetedSearchCompactContainer from './Containers/FacetedSearchCompact.container';
import NotificationContainer from './Containers/Notification.container';
import DynamicComponent from './Components/DynamicComponent';
import DatePickerContainer from './Containers/DatePicker.container';
import './extras';
import './woo-scripts/carousel';
import { myPagesFilterWrapper } from './woo-scripts/mypages-filter';
import { sideBarWrapper } from './woo-scripts/side-bar';
import { tabsWrapper } from './woo-scripts/tabs';

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
// use the parent page's store if possible, so the iframe will share the same store with the parent context.
// this to makes for example the Reorder button in My Page page to update the state and reload the mini cart
// when reorder action happens.
const store = (window.__litium.store =
  window.__litium.store ||
  (window.parent.__litium && window.parent.__litium.store) ||
  createStore(
    app,
    preloadState,
    composeWithDevTools(applyMiddleware(thunk, historyMiddleware)),
  ));
window.__litium = {
  ...window.__litium,
  bootstrapComponents: () => {
    // bootstrap React components, in case the HTML response we receive from the server
    // has React components. ReactDOM.render performs only an update on previous rendered
    // components and only mutate the DOM as necessary to reflect latest React element.
    bootstrapComponents();
  },
  cache: {}, // for storing cache data for current request
};

window.onload = function () {
  if (document.getElementById('js-product-page')) tabsWrapper();

  if (document.getElementById('js-my-pages')) sideBarWrapper();

  if (document.getElementById('js-order-history'))
    myPagesFilterWrapper('/api/pyramid/ordernumbers');

  if (document.getElementById('js-offer-history'))
    myPagesFilterWrapper('/api/pyramid/offernumbers');

  if (document.getElementById('js-invoice-history'))
    myPagesFilterWrapper('/api/pyramid/invoicenumbers');
};

const bootstrapComponents = () => {
  if (document.getElementById('date-picker-from')) {
    ReactDOM.render(
      <DatePickerContainer placeholder="mypages.filter.fromdate" name="from" />,
      document.getElementById('date-picker-from'),
    );
  }
  if (document.getElementById('date-picker-to')) {
    ReactDOM.render(
      <DatePickerContainer placeholder="mypages.filter.todate" name="to" />,
      document.getElementById('date-picker-to'),
    );
  }
  if (document.getElementById('miniCart')) {
    ReactDOM.render(
      <Provider store={store}>
        <MiniCartContainer />
      </Provider>,
      document.getElementById('miniCart'),
    );
  }
  if (document.getElementById('quickSearch')) {
    ReactDOM.render(
      <Provider store={store}>
        <QuickSearchContainer />
      </Provider>,
      document.getElementById('quickSearch'),
    );
  }
  if (document.getElementById('navbar')) {
    const navbar = document.getElementById('navbar');
    const catalogLink = navbar.getAttribute('data-catalog-link');
    ReactDOM.render(
      <Provider store={store}>
        <NavigationContainer catalogLink={catalogLink} />
      </Provider>,
      document.getElementById('navbar'),
    );
  }
  if (document.getElementById('facetedSearch')) {
    ReactDOM.render(
      <Provider store={store}>
        <FacetedSearchContainer />
      </Provider>,
      document.getElementById('facetedSearch'),
    );
  }
  if (document.getElementById('facetedSearchCompact')) {
    ReactDOM.render(
      <Provider store={store}>
        <FacetedSearchCompactContainer />
      </Provider>,
      document.getElementById('facetedSearchCompact'),
    );
  }
  if (document.getElementById('globalNotification')) {
    ReactDOM.render(
      <Provider store={store}>
        <NotificationContainer />
      </Provider>,
      document.getElementById('globalNotification'),
    );
  }

  if (document.getElementById('myPagePersons')) {
    const PersonList = DynamicComponent({
      loader: () => import('./Containers/PersonList.container'),
    });
    ReactDOM.render(
      <Provider store={store}>
        <PersonList />
      </Provider>,
      document.getElementById('myPagePersons'),
    );
  }
  if (document.getElementById('myPageAddresses')) {
    const AddressList = DynamicComponent({
      loader: () => import('./Containers/AddressList.container'),
    });
    ReactDOM.render(
      <Provider store={store}>
        <AddressList />
      </Provider>,
      document.getElementById('myPageAddresses'),
    );
  }
  if (document.getElementById('checkout')) {
    const Checkout = DynamicComponent({
      loader: () => import('./Containers/Checkout.container'),
    });
    ReactDOM.render(
      <Provider store={store}>
        <Checkout />
      </Provider>,
      document.getElementById('checkout'),
    );
  }

  if (document.getElementById('lightBoxImages')) {
      const rootElement = document.getElementById('lightBoxImages');
      const downloadData = {
          url: rootElement.getAttribute('data-download-url'),
          text: rootElement.getAttribute('data-download-text'),
          pdfUrl: rootElement.getAttribute('data-pdf-url'),
          pdfText: rootElement.getAttribute('data-pdf-text')
      };
      const images = Array.from(rootElement.querySelectorAll('a')).map(img => ({
          src: img.dataset.src,
      }));
      const thumbnails = Array.from(
          rootElement.querySelectorAll('a img'),
      ).map(img => ({ src: img.src }));
      const LightboxContainer = DynamicComponent({
          loader: () => import('./Containers/LightboxImages.container'),
      });

      ReactDOM.render(
          <Provider store={store}>
              <LightboxContainer 
                  images={images} 
                  thumbnails={thumbnails} 
                  downloadData={downloadData} 
              />
          </Provider>,
          rootElement
      );
  }

  if (document.querySelectorAll('.slider').length > 0) {
    const Slider = DynamicComponent({
      loader: () => import('./Components/Slider'),
    });
    Array.from(document.querySelectorAll('.slider')).forEach(
      (slider, index) => {
        const values = [...slider.querySelectorAll('.slider__block')].map(
          block => {
            return {
              image: block.dataset.image,
              url: block.dataset.url,
              text: block.dataset.text,
              button: block.dataset.button,
            };
          },
        );
        if (values.length > 0) {
          ReactDOM.render(<Slider values={values} />, slider);
        }
      },
    );
  }

  if (document.querySelectorAll('buy-button').length > 0) {
    const BuyButton = DynamicComponent({
      loader: () => import('./Containers/BuyButton.Container'),
    });
    Array.from(document.querySelectorAll('buy-button')).forEach(button => {
      const { articleNumber, quantityFieldId, href, cssClass } = button.dataset;
      const label = button.innerText;
      ReactDOM.render(
        <Provider store={store}>
          <BuyButton
            {...{ label, articleNumber, quantityFieldId, href, cssClass }}
          />
        </Provider>,
        button,
      );
    });
  }

  if (document.querySelectorAll('reorder-button').length > 0) {
    const ReorderButton = DynamicComponent({
      loader: () => import('./Containers/ReorderButton.Container'),
    });
    Array.from(document.querySelectorAll('reorder-button')).forEach(button => {
      const { cssClass, rowsJson, title } = button.dataset;
      const label = button.innerText;
      ReactDOM.render(
        <Provider store={store}>
          <ReorderButton {...{ label, title, cssClass, rowsJson }} />
        </Provider>,
        button,
      );
    });
  }

  if (document.querySelectorAll('pyramid-reorder-button').length > 0) {
    const PyramidReorderButton = DynamicComponent({
      loader: () => import('./Containers/PyramidReorderButton.Container'),
    });
    Array.from(document.querySelectorAll('pyramid-reorder-button')).forEach(
      button => {
        const { cssClass, rowsJson, title } = button.dataset;
        const label = button.innerText;
        ReactDOM.render(
          <Provider store={store}>
            <PyramidReorderButton {...{ label, title, cssClass, rowsJson }} />
          </Provider>,
          button,
        );
      },
    );
  }

  if (document.querySelectorAll('pyramid-order-from-offer-button').length > 0) {
    const PyramidOrderFromOfferButton = DynamicComponent({
      loader: () =>
        import('./Containers/PyramidOrderFromOfferButton.Container'),
    });
    Array.from(
      document.querySelectorAll('pyramid-order-from-offer-button'),
    ).forEach(button => {
      const { cssClass, offerNo, title } = button.dataset;
      const label = button.innerText;
      ReactDOM.render(
        <Provider store={store}>
          <PyramidOrderFromOfferButton
            {...{ label, title, cssClass, offerNo }}
          />
        </Provider>,
        button,
      );
    });
  }

  if (document.getElementById('pcon-modal')) {
    const PconModal = DynamicComponent({
      loader: () => import('./Containers/PconModal.container'),
    });
    const modal = document.getElementById('pcon-modal');
    const { src } = modal.dataset;
    ReactDOM.render(
      <Provider store={store}>
        <PconModal {...{ src }} />
      </Provider>,
      modal,
    );
  }
};

bootstrapComponents();
